import { parseAsBase64Json } from "./parseAsBase64Json";

/** Опции parser-а query-фильтра. */
export interface UrlFilterParserOptions<T extends object = Record<string, unknown>> {
    validate?: (parsed: unknown) => T;
    defaultFilter?: T | null;
}

/** Создаёт `nuqs`-parser для query-фильтра списка. */
export function createUrlFilterParser<T extends object = Record<string, unknown>>(options: UrlFilterParserOptions<T> = {}) {
    const { validate, defaultFilter = null } = options;
    const baseParser = parseAsBase64Json<T>(validate);
    return defaultFilter === null ? baseParser : baseParser.withDefault(defaultFilter);
}
